/*
 *
 *  * Copyright (c) [hoarfroster-frontend] 2026. All Rights Reserved.
 *  *
 *  * Last Modified on May 22, 2026 by hoarfroster
 *
 */

import Header from '@components/header';
import { Outlet } from 'react-router';
import { GlobalAuthInterceptor } from '@components/auth/intercept-dialog';

export default function AppLayout() {
    return (
        <div className="text-theme-text flex min-h-screen flex-col bg-(image:--theme-bg-image) bg-cover bg-center bg-no-repeat">
            <Header />

            <div className="flex h-[calc(100dvh-3.875rem)] flex-col overflow-y-auto">
                <GlobalAuthInterceptor />
                <Outlet />
            </div>
        </div>
    );
}
